import React from 'react';
import cn from 'clsx';
import { ColorValueStrict } from 'fronton-react';
import { ChevronRightIcon } from '@fronton/icons-react';
import { Typography } from 'common/components/typography';
import { bannerName, bannerNameChevronIcon, bannerNameWrapper } from './banner-header-styles';

type BannerHeaderProps = {
  className?: string;
  title: string;
  textColor?: ColorValueStrict;
};

export const BannerHeader: React.FC<BannerHeaderProps> = ({ className, title, textColor }) => (
  <div className={cn(bannerNameWrapper, className)}>
    <Typography className={bannerName} variant="h2" color={textColor || 'text-invert'}>
      {title}
    </Typography>
    <ChevronRightIcon
      className={bannerNameChevronIcon}
      type="outline"
      size="l"
      color={textColor || 'text-invert'}
    />
  </div>
);
